
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { RoleItemProps } from ".";
import { loading, find } from "store/role";

interface ApiRoleFindByIdInputProps {
    id: number;
}

type ApiRoleFindOutputProps = OutputBaseProps<{ item: RoleItemProps; }, ApiRoleFindByIdInputProps>

export const apiRoleFindById = async (data: ApiRoleFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiRoleFindOutputProps>(`/api/role/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiRoleFindByCodeInputProps {
    code: string;
}

export const apiRoleFindByCode = async (data: ApiRoleFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiRoleFindOutputProps>(`/api/role/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};